// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Fetch from "../../../../../bs-fetch/src/Fetch.bs.js";
import * as Caml_option from "../../../../../rescript/lib/es6/caml_option.js";
import * as PromiseHandler$Catalyst from "./PromiseHandler.bs.js";

function getDefaultHeaders(param) {
  return {
          "Content-Type": "application/json"
        };
}

var NetworkUtils = {
  getDefaultHeaders: getDefaultHeaders
};

function postRequest(requestUrl, payload, timeoutMsOpt, _unit) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : 15000;
  var promise = fetch(requestUrl, Fetch.RequestInit.make(/* Post */2, {
              "Content-Type": "application/json"
            }, Caml_option.some(payload), undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  return PromiseHandler$Catalyst.PromiseHandler.resolvePromise(promise, timeoutMs, requestUrl);
}

function postRequestV2(requestUrl, payload, header, timeoutMsOpt, _unit) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : 15000;
  var promise = fetch(requestUrl, Fetch.RequestInit.make(/* Post */2, Caml_option.some(Object.assign({
                      "Content-Type": "application/json",
                      Accept: "application/json",
                      "Access-Control-Allow-Origin": "*",
                      "Access-Control-Allow-Credentials": true
                    }, header)), Caml_option.some(payload), undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  return PromiseHandler$Catalyst.PromiseHandler.resolvePromise(promise, timeoutMs, requestUrl);
}

function putRequest(requestUrl, payload, authToken, timeoutMsOpt, _unit) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : 15000;
  var promise = fetch(requestUrl, Fetch.RequestInit.make(/* Put */3, {
              "Content-Type": "application/json",
              Accept: "application/json",
              DRIVER_AUTH_TOKEN: authToken
            }, Caml_option.some(payload), undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  return PromiseHandler$Catalyst.PromiseHandler.resolvePromise(promise, timeoutMs, requestUrl);
}

function deleteRequest(requestUrl, timeoutMsOpt, __unit) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : 15000;
  var promise = fetch(requestUrl, Fetch.RequestInit.make(/* Delete */4, {
              "Content-Type": "application/json"
            }, undefined, undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  return PromiseHandler$Catalyst.PromiseHandler.resolvePromise(promise, timeoutMs, requestUrl);
}

function getRequestV2(requestUrl, timeoutMsOpt, retryCountOpt, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : 15000;
  var retryCount = retryCountOpt !== undefined ? retryCountOpt : 3;
  var promiseGenerator = function (param) {
    return fetch(requestUrl, Fetch.RequestInit.make(/* Get */0, {
                      "Content-Type": "application/json"
                    }, undefined, undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  };
  return PromiseHandler$Catalyst.PromiseHandler.resolvePromiseWithRetry(promiseGenerator, timeoutMs, retryCount, requestUrl);
}

function getRequestV3(requestUrl, authToken, timeoutMsOpt, retryCountOpt, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : 15000;
  var retryCount = retryCountOpt !== undefined ? retryCountOpt : 3;
  var promiseGenerator = function (param) {
    return fetch(requestUrl, Fetch.RequestInit.make(/* Get */0, {
                      "Content-Type": "application/json",
                      DRIVER_AUTH_TOKEN: authToken
                    }, undefined, undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  };
  return PromiseHandler$Catalyst.PromiseHandler.resolvePromiseWithRetry(promiseGenerator, timeoutMs, retryCount, requestUrl);
}

function getRequestV4(requestUrl, authToken, timeoutMsOpt, retryCountOpt, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : 15000;
  var retryCount = retryCountOpt !== undefined ? retryCountOpt : 3;
  var promiseGenerator = function (param) {
    return fetch(requestUrl, Fetch.RequestInit.make(/* Get */0, {
                      "Content-Type": "application/json",
                      "driver-auth-token": authToken
                    }, undefined, undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined));
  };
  return PromiseHandler$Catalyst.PromiseHandler.resolvePromiseWithRetry(promiseGenerator, timeoutMs, retryCount, requestUrl);
}

var maxRetryCount = 3;

var maxTimeoutMs = 15000;

export {
  maxRetryCount ,
  maxTimeoutMs ,
  NetworkUtils ,
  postRequest ,
  postRequestV2 ,
  putRequest ,
  deleteRequest ,
  getRequestV2 ,
  getRequestV3 ,
  getRequestV4 ,
  
}
/* PromiseHandler-Catalyst Not a pure module */
